// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"472":"settings","594":"about"}[chunkId] + "." + {"472":"8a241316","594":"84497586"}[chunkId] + ".css";
};